import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { useAuth } from 'src/hooks/useAuth';
import { useConfig } from 'src/hooks/useConfig';
import DashboardOverview from 'src/dashboard-new/components/DashboardOverview/DashboardOverview';
import SideBarLayout from 'src/shared/layouts/SideBarLayout';
import DocumentsListContainer from 'src/documents-new/DocumentsListContainer';
import NewUIMessageModal from 'src/document-edit/components/NewUIMessageModal/NewUIMessageModal';
import SelectDocumentType from 'src/documents-new/components/SelectDocumentType/SelectDocumentType';
import styles from './style';

const DashboardNew = () => {
  const { t } = useTranslation();
  const { BRAND_NAME, IS_BRAND_PROCYS } = useConfig();
  const { user } = useAuth();

  const [showNewUIMsg, setShowNewUIMsg] = useState<boolean>(!user?.disableUISwitch && !user?.hasSeenNewUI && user?.userRole === 'admin');
  
  return (
    <>
      {
        !user?.documentType && <SelectDocumentType open />
      }
      <SideBarLayout title={`${t('DASHBOARD_ACTION_DASHBOARD')} | ${BRAND_NAME}`}>
        <Grid sx={styles.root}>
          <DashboardOverview />
          <DocumentsListContainer />
        </Grid>
        <NewUIMessageModal
          open={showNewUIMsg && IS_BRAND_PROCYS}
          handleClose={() => setShowNewUIMsg(false)}
        />
      </SideBarLayout> 
    </>
  )
}

export default DashboardNew